export interface ColoringPage {
  id: string;
  childId: string;
  actualChildId?: string;  // The actual child ID when using parent authentication
  imageUrl: string;
  prompt: string;
  createdAt: Date;
  cost: number;
}

export interface ColoringPageCollection {
  id: string;
  childId: string;
  originalColoringPageId: string;
  imageUrl: string;
  prompt: string;
  addedAt: Date;
}
